import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../../theme";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();

  return (
    <button
      type="button"
      onClick={toggle}
      className="theme-toggle relative"
      aria-label="Toggle dark mode"
      data-testid="dark-mode-toggle"
    >
      <span className="theme-toggle__knob" />
      <Sun
        size={12}
        className="absolute left-1.5 top-1/2 -translate-y-1/2 opacity-60 pointer-events-none"
        aria-hidden
      />
      <Moon
        size={12}
        className="absolute right-1.5 top-1/2 -translate-y-1/2 opacity-60 pointer-events-none"
        aria-hidden
      />
      <span className="sr-only">Current theme: {theme}</span>
    </button>
  );
}
